import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import AttendanceInfoDrawer from "./modules/AttendanceInfoDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'AttendanceInfoList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    AttendanceInfoDrawer: AttendanceInfoDrawer
  },
  data: function data() {
    return {
      showSite: true,
      pagePath: '/om/attendance/info',
      pageTitle: '考勤记录',
      addDisabled: false,
      userTree: [],
      //人员信息
      isorter: {
        column: 'id',
        order: 'desc'
      },
      siteName: '',
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      pipeColumn: {
        dataIndex: 'siteName',
        colName: '',
        title: '管网',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '打卡人员',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'onDate',
        colName: 'on_date',
        title: '上班打卡时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'offDate',
        colName: 'off_date',
        title: '下班打卡时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'workHour',
        colName: 'work_hour',
        title: '工作时长',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    if (window.localStorage.getItem('projectCode')) {
      if (window.localStorage.getItem('projectCode') == 'meitang') {
        this.showSite = false;
      }
    }

    this.queryUserTreeList();
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];
      this.$refs.modalForm.siteName = ids[1];

      if (ids[0] == 1) {
        // 根据站点id
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  computed: {},
  methods: {
    onDateOnDate: function onDateOnDate(value, dateArray) {
      this.queryParam.onDateStart = dateArray[0];
      this.queryParam.onDateEnd = dateArray[1];
    },
    onDateOffDate: function onDateOffDate(value, dateArray) {
      this.queryParam.offDateStart = dateArray[0];
      this.queryParam.offDateEnd = dateArray[1];
    },
    // 1.站点 2.流域 3.管网  由于没有流域所以1.站点2.管网4.区域
    // 站点选择
    siteChange: function siteChange(data) {
      var _this = this;

      console.log(data);
      this.siteName = data.data.name == undefined ? data.data.title : data.data.name;
      this.queryParam.scopeId = data.data.id;
      this.queryParam.scope = data.scope;
      this.siteId = data.data.id;
      this.$refs.modalForm.model.siteName = data.data.name == undefined ? data.data.title : data.data.name;
      this.$refs.modalForm.model.siteId = data.data.id;
      this.$refs.modalForm.model.siteType = data.type;
      this.columns.forEach(function (v, i) {
        if (v.dataIndex.indexOf('siteName') >= 0 || v.dataIndex.indexOf('pipeName') >= 0) {
          _this.columns.splice(i, 1);
        }
      });

      if (1 == data.type) {
        this.queryParam.siteType = data.type;
        this.siteType = data.type;
        this.judgmentValue = data.type;
      } else if (2 == data.type) {
        this.queryParam.siteType = data.type;
        this.siteType = data.type;
        this.judgmentValue = data.type;
      }

      if (4 == data.type) {
        // 根据区域
        this.spliceColumn(1 == this.judgmentValue ? this.siteColumn : this.pipeColumn, 1);
      }

      this.addDisabled = data.scope == 1 ? false : true;
      this.loadData();
    },
    queryUserTreeList: function queryUserTreeList() {
      var _this2 = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this2.loading = false;
        }
      });
    },
    handleAdd: function handleAdd() {
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
      this.$refs.modalForm.siteName = this.siteName;
      this.$refs.modalForm.siteId = this.siteId;
      this.$refs.modalForm.siteType = this.siteType;
      this.$refs.modalForm.add();
    },
    modalFormOk: function modalFormOk() {
      this.queryParam = {
        scopeId: this.queryParam.scopeId,
        scope: this.queryParam.scope,
        siteId: this.siteId,
        siteType: this.siteType
      };
      this.loadData();
    },
    searchReset: function searchReset() {
      this.queryParam = {
        scopeId: this.queryParam.scopeId,
        scope: this.queryParam.scope,
        siteId: this.siteId,
        siteType: this.siteType
      };
      this.dates = {};
      this.loadData(1);
    }
  }
};